import { usePageMetadata } from "../../Core/Content/Hooks";
import { useEffect, useRef, useState } from "react";
import AppService from "../../service/app.service";

export const useMenuHook = () => {
  const [menuPageData, setMenuPageData] = useState(null);
  usePageMetadata(menuPageData, "SouledOut | Menu");
  const appService = new AppService();
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchedRef = useRef(false);
  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    (async () => {
      try {
        const result = await appService.getPage("menu");
        setMenuPageData(result.data);
        setError(result.error);
        setIsLoading(result.isLoading);
      } catch (e: any) {
        setError(e);
        setIsLoading(false);
      }
    })();
  }, []);

  return {
    menuPageData,
    error,
    isLoading,
  };
};
